import { Component } from "@angular/core";
import { CatalogService } from "../../services/catalog.service";
import { WindowService } from "../../services/window.service";

@Component({
  template: `
    <section>
      <router-outlet #catalogsOutlet="outlet"> </router-outlet>
    </section>
  `,
})
export class CatalogsComponent {
  constructor(
    private catalogService: CatalogService,
    private windowService: WindowService
  ) {}

  // change the animation state
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }
}
